import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useStore } from "@/stores/useStore";

export const useIsAuthenticated = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { authState, initialized } = useStore();

  useEffect(() => {
    if (!initialized) return;
    switch (authState) {
      case "authenticated":
        if (location.pathname === "/login") {
          navigate("/");
        }
        if (location.pathname === "/register") {
          navigate("/");
        }
        break;
      case "unauthenticated":
        if (location.pathname === "/login") {
          return;
        }
        if (location.pathname === "/register") {
          return;
        }
        navigate("/login");
        break;
    }
  }, [navigate, authState, location, initialized]);
};
